import styled from '@emotion/styled'

export const FooterWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`
